// App.js - WEB
import React, {PureComponent} from "react";
import {View, Text, Button, FlatList, TouchableOpacity, Linking, Platfor, Image, Platform} from "react-native";

//let LottieView = null;
import LottieView from "../../../importCalss/LottieView";
//import LottieView from "react-native-web-lottie";
import PathFile from "../../../assets/PathFile";
import {typeExport} from "../../../redux/store/type";
import i18n from "../../../I18n/i18n";
import AsyncStorage from "@react-native-community/async-storage";
import {AsyngStorageClass} from "../../../tools/AsyngStorageClass";
import store from "../../../redux/store";
// import {Tools} from "../../../tools/Tools";
import {BackgroundImage} from "../../../tools/Tools1";
import * as NavigationService from "../../../redux/NavigationService";
import NetInfo from "@react-native-community/netinfo";
import {
    serviceActionListNotSendMyApply,
    serviceActionSetIsConnected, serviceActionSetNameDynamic, serviceActionSetState,
    serviceActionSetTokenMahaleh
} from "./action/ActionSplashGetAllData";
import DialogConnectionCustomize from "../../../customviews/DialogConnectionCustomize";

let content = null;
let dataWordPress = null;
let dataSaina = null;
let dataShahrdar = null;
let data125 = null;
let TypeLogin = 1;
export default class SplashScreen extends PureComponent {
    constructor(props) {
        super(props);


        props.callServiceRefresh();

        if (props.route?.params?.routeName && props.route?.params?.typeSelectMenu) {

            props.callServiceSetState({
                type: props.route.params.routeName,
                typeSelectMenu: props.route.params.typeSelectMenu
            });
        }
        global._loadDataCount = 0
    }

    state = {
        type_getData: typeExport.TypeGetAllData,
        ShowDialogUpdateAppCustomize: false,
        imageBackground: null,
        source: null,
        token: null,
        OnceDo: true,
    };

    async componentWillMount() {


        if (global.token_fb) {
            this.props.callServiceTokenFirebase(global.token_fb);
        }
        else {
            let fcmToken = await AsyncStorage.getItem('fcmToken');
            this.props.callServiceTokenFirebase(fcmToken);


        }

        global.ErrorLogin = false;
        console.log("componentDidMount@@@")

        // Tools.CheckNetWork("b");
        //   Tools.changeAppLang("fa");


        // NetInfo.isConnected.addEventListener(
        //     'connectionChange',
        //     this._handleConnectivityChange
        //
        // );
        //
        // NetInfo.isConnected.fetch().done((isConnected) => {
        //
        //     // if(isConnected == true)
        //     // {
        //     //     this.setState({connection_Status : "Online"})
        //     // }
        //     // else
        //     // {
        //     //     this.setState({connection_Status : "Offline"})
        //     // }
        //
        // });
        //this.remove()
        // alert(DeviceInfo.getBuildNumber())
        //  var path = RNFS.DocumentDirectoryPath + '/test.txt';

        this.getData();

        // Tools.Request(typeExport.GET, "", '', '', '', '', '')
        // this.remove()
    }

 /*   componentDidMount() {
        global.ErrorLogin = false;
        console.log("componentDidMount@@@")

        // Tools.CheckNetWork("b");
        //   Tools.changeAppLang("fa");


        // NetInfo.isConnected.addEventListener(
        //     'connectionChange',
        //     this._handleConnectivityChange
        //
        // );
        //
        // NetInfo.isConnected.fetch().done((isConnected) => {
        //
        //     // if(isConnected == true)
        //     // {
        //     //     this.setState({connection_Status : "Online"})
        //     // }
        //     // else
        //     // {
        //     //     this.setState({connection_Status : "Offline"})
        //     // }
        //
        // });
        //this.remove()
        // alert(DeviceInfo.getBuildNumber())
        //  var path = RNFS.DocumentDirectoryPath + '/test.txt';

        this.getData();

        // Tools.Request(typeExport.GET, "", '', '', '', '', '')
        // this.remove()
    }*/

    async getData() {

        this.getAsyncStorage();
        /*    if (Platform.OS === 'android') {
                NetInfo.isConnected.fetch().then(isConnected => {
                    if (isConnected) {
                        this.getAsyncStorage();
                    }
                    else {
                        //  this.props.callServiceError("offline")
                        this.offlineToMain()
                    }
                });
            }
            else {
                this.props.Connection ?
                    this.getAsyncStorage()
                    :

                    /!*   dispatch(serviceActionSuccess(data));
               dispatch(serviceActionTokenFirebase(params.token_fb));
               dispatch(serviceActionBackground(imageBackground));*!/
                    this.offlineToMain()
                //   this.props.callServiceError("offline")


            }*/

    }

    componentWillUnmount() {
        // Tools._RemoveConnectivity()
        // NetInfo.isConnected.removeEventListener(
        //     'connectionChange',
        //     Tools._handleConnectivityChange
        //
        // );
        //  this.props.callServiceRefresh()
    }

    async remove() {
        try {
            //await AsyncStorage.removeItem(IDCITY);
            //await AsyncStorage.removeItem(TOKEN);
            //this.props.navigation.navigate("LoginEnterPhoneScreen", {type_login: ""})

            //await AsyncStorage.removeItem(ImageSplash);
        } catch (error) {
            alert(i18n.t('typeExport.retry'));
        }
    }


    async componentWillReceiveProps(propss) {


        // if (propss.results !== null || propss.resultsShahrdar !== null) {
        //
        //
        //
        //     TypeLogin == 1 || TypeLogin == null ?
        //         NavigationService.navigatereset('Drawer')
        //         :
        //         NavigationService.navigatereset('DrawerStackShahrdar')
        //
        //
        // }

    }

    goScreen() {

        NavigationService.resetTo('DrawerScreen');
        /*       switch (typeExport._TypeApp) {
                   case"Satia":
                       //      import RouterOperationSatia from "./satia/RouterOperationSatia";
       // import Router137 from "./137/Router137";
       // import RouterSatia from "./satia/RouterSatia";
       // import Router125 from "./125/Router125";
                       if (typeExport._NameApp === "SatiaOperator") {
                           let RouterOperationSatia = require("./satia/RouterOperationSatia").default;
                           return <RouterOperationSatia/>;

                       }
                       else {
                           let RouterSatia = require("./satia/RouterSatia").default;

                           return <RouterSatia/>;

                       }

                   case"125":
                       let Router125 = require("./125/Router125").default;

                       return <Router125/>;

                   default:
                       NavigationService.resetTo('DrawerScreen')


               }
                       TypeLogin == 1 || TypeLogin == null ?
                           NavigationService.resetTo('DrawerScreen')
                           :
                           TypeLogin == 2 ?
                               NavigationService.resetTo('DrawerStackShahrdar') : NavigationService.resetTo('Drawer125')*/

    }

    async offlineToMain(connection, params) {
        global.GoOfflineToMain = true;
        global._loadDataCount = 1;

        //
        //   alert("yyy")
        /*   let dataWordPress = await AsyngStorageClass.getASyng("splash"+global.IdCity)
           let dataSaina = await AsyngStorageClass.getASyng("splashSaina"+global.IdCity)*/
        store.dispatch(serviceActionSetIsConnected(connection));


        if (TypeLogin == 1 || TypeLogin == null) {
            if (dataWordPress !== null && dataSaina !== null) {

                //  setIsConnected(false)

                this.props.callServiceSuccessSaina(dataSaina);

                this.props.callServiceBackground(this.state.ImageBackground);
                this.props.callServiceTokenFirebase(this.state.token_fb);
                let user = await AsyngStorageClass.getASyng(typeExport._USER);
                this.props.callServiceSetUser(user);

                this.props.callServiceSuccess(dataWordPress, user ? user.token : null);
                this.goScreen();
                //   this.props.callServiceSetToken(dataSaina)
                //   this.props.callServiceSetUser(dataSaina)
            }
            else {

                if (this.state.OnceDo) {
                    this.setState({OnceDo: false}, async () => {

                        // let token = await AsyngStorageClass.checkToken();
                        // this.props.callServiceSetToken(token);
                        // let token_fb = await AsyncStorage.getItem('fcmToken');


                        this.setState({
                                // source: image,
                                imageBackground: null,
                                // token: token,
                                //  token_fb: token_fb,
                            },
                            () => {
                            });

                        this.props.callService(typeExport.urlGetAllDataSaina, params, typeExport.TypeGetAllDataSaina, typeExport._GET, this.state.token, this.state.token_fb, null);
                    });
                } else {
                    this.props.callServiceError('offline');
                }


            }
        }
        else if (TypeLogin == 2) {

            if (dataShahrdar !== null) {

                //  setIsConnected(false)
                console.log("dataShahrdar@@@", dataShahrdar);
                this.props.callServiceSuccessSahrdar(dataShahrdar);

                this.props.callServiceBackground(this.state.ImageBackground);
                this.props.callServiceTokenFirebase(this.state.token_fb);
                let user = await AsyngStorageClass.getASyng(typeExport._USER);
                this.props.callServiceSetUser(user);
                this.goScreen();

            }
            else {

                if (this.state.OnceDo) {
                    this.setState({OnceDo: false}, async () => {

                        //    let token = await AsyngStorageClass.checkToken();
                        //   this.props.callServiceSetToken(token);
                        //  let token_fb = await AsyncStorage.getItem('fcmToken');


                        this.setState({
                                // source: image,
                                imageBackground: null,
                                //     token: token,
                                //   token_fb: token_fb,
                            },
                            () => {
                            });

                        this.props.callService(typeExport.urlGetAllDataSaina, params, typeExport.TypeGetAllDataSaina, typeExport._GET, this.state.token, this.state.token_fb, null);
                    });
                } else {
                    this.props.callServiceError('offline');
                }


            }
        } else if (TypeLogin == 3) {

            if (data125 !== null) {

                //  setIsConnected(false)

                this.props.callServiceSuccess125(data125);

                this.props.callServiceBackground(this.state.ImageBackground);
                this.props.callServiceTokenFirebase(this.state.token_fb);
                let user = await AsyngStorageClass.getASyng(typeExport._USER);
                this.props.callServiceSetUser(user);
                this.goScreen();

            }
            else {

                if (this.state.OnceDo) {
                    this.setState({OnceDo: false}, async () => {

                        //    let token = await AsyngStorageClass.checkToken();
                        //  this.props.callServiceSetToken(token);
                        //   let token_fb = await AsyncStorage.getItem('fcmToken');


                        this.setState({
                                // source: image,
                                imageBackground: null,
                                //  token: token,
                                // token_fb: token_fb,
                            },
                            () => {
                            });


                        this.props.callService(global.UrlWebService125, params, typeExport.TypeGetAllData125, typeExport._GET, this.state.token, this.state.token_fb, null);
                    });
                } else {
                    this.props.callServiceError('offline');
                }


            }
        }
        else {
            alert("!!!!2")
        }

    }

    async login() {
        this.props.callServiceBackground(this.state.imageBackground);

        //NavigationService.navigatereset('LoginEnterPhoneScreen');
        NavigationService.navigate('LoginStackScreen');
    }


    async getAsyncStorage() {
        if ((typeExport._NameApp === "Cloud" || typeExport._NameApp === "CloudTest")) {
            let City = await AsyngStorageClass.getASyng('City');
            //  this.props.callServiceTokenFirebase(token_fb);
            store.dispatch(serviceActionSetNameDynamic("City",
                City
            ));
            let OrganCity = await AsyngStorageClass.getASyng('OrganCity');
            //  this.props.callServiceTokenFirebase(token_fb);
            store.dispatch(serviceActionSetNameDynamic("OrganCity",
                OrganCity
            ));

            /*    if (!Tools.CheckValue(City)) {
                    NavigationService.navigateParams("ListCityScreen");
                    return true;
                }*/

        }

        let token_fb = await AsyncStorage.getItem('fcmToken');
        this.props.callServiceTokenFirebase(token_fb);

        let tokenMahaleh = await AsyngStorageClass.getASyng("tokenMahaleh");
        this.props.callServiceSetTokenMahaleh(tokenMahaleh);

        let tokenLaravel = await AsyngStorageClass.getASyng("tokenLaravel");
        this.props.callServiceSetTokenLaravel(tokenLaravel);

        /* let ListNotSendMyApply = await AsyngStorageClass.getASyng(global.IdCity + typeExport.ListMyApplyOffline + 5);
         this.props.callServiceListNotSendMyApply(ListNotSendMyApply);*/


        //125
        //   TypeLogin = 3;


        if (typeExport._TypeApp == "125") {
            TypeLogin = 3;
            global.UrlWebService125 = await AsyngStorageClass.getASyng(typeExport._UrlWebService125);
            global.UrlWebService125 = global.UrlWebService125 ? global.UrlWebService125 : typeExport._baseUrl125;
            global._Device = await AsyngStorageClass.getASyng(typeExport._DeviceType);
        }
        else {
            TypeLogin = await AsyngStorageClass.getASyng(typeExport._TypeLogin);
            if (TypeLogin == 3) {
                TypeLogin = null
            }
        }
        //Mahalema
        //TypeLogin = 2;

        //**************//
        // let intro = await AsyngStorageClass.getASyng(typeExport._INTRO);
        // if (!intro)
        // {
        //     this.props.navigation.replace("IntroScreen")
        //
        //     return false
        // }
        //**************//

        this.props.callServiceSetTypeLogin(TypeLogin);
        let token =null;
        if (this.props.route?.params?.token &&Platform.OS==="web") {
            token="Bearer "+this.props.route?.params?.token;
            await AsyngStorageClass.setAsyng(typeExport.TOKEN,token);

        }
        else {
            token = await AsyngStorageClass.checkToken();
        }
            this.props.callServiceSetToken(token);
        this.setState({
            token: token,
            token_fb: token_fb,
        })
        // if (TypeLogin == 3 && !token) {
        //     this.props.navigation.replace("LoginStack")
        //     return false
        // }
        //  let TypeLogin = 1;


        var imageBack = [];

        // imageBack = Tools.BackgroundImage(null);
        imageBack = BackgroundImage(null);

        this.setState({
                // source: image,
                imageBackground: imageBack,
                // token: token,
                //token_fb: token_fb,
            },
            () => {
            });

        let paramss = {
            'token': token,
            'token_mahale': tokenMahaleh,
            'tokenLaravel': tokenLaravel,
            'id': 1,
            'lang': i18n.locale,
            'imei': 0,
            'token_fb': token_fb,


        };

        if (TypeLogin == 1 || TypeLogin == null) {


            dataSaina = await AsyngStorageClass.getASyng('splashSaina' + global.IdCity);
            if (dataSaina != null) {


                dataWordPress = await AsyngStorageClass.getASyng('splash' + global.IdCity);
            }


            if (Platform.OS === 'android') {
                NetInfo.fetch().then(state => {
                    let isConnected = state.isConnected;

                    if (isConnected && (dataSaina == null || dataWordPress == null)) {

                        this.props.callService(typeExport.urlGetAllDataSaina, paramss, typeExport.TypeGetAllDataSaina, typeExport._GET, token, token_fb, imageBack);

                        /*     if (dataSaina == null) {
                                 this.props.callService(typeExport.urlGetAllData, paramss, typeExport.TypeGetAllData, typeExport._GET, token, token_fb, imageBack);
                             } else {
                                 this.props.callService(typeExport.urlGetAllDataSaina, paramss, typeExport.TypeGetAllDataSaina, typeExport._GET, token, token_fb, imageBack);
                             }*/
                    } else {
                        //  this.props.callServiceError("offline")
                        this.offlineToMain(isConnected, paramss);
                    }
                });
            }
            else {
                if (this.props.Connection && (dataSaina == null || dataWordPress == null)) {

                    if (this.props.resultsSaina != null) {
                        this.props.callService(typeExport.urlGetAllData, paramss, typeExport.TypeGetAllData, typeExport._GET, token, token_fb, imageBack);

                    } else {
                        this.props.callService(typeExport.urlGetAllDataSaina, paramss, typeExport.TypeGetAllDataSaina, typeExport._GET, token, token_fb, imageBack);
                    }

                } else {

                    this.offlineToMain(this.props.Connection, paramss);
                }
            }
        }
        else if (TypeLogin == 2) {
            dataShahrdar = await AsyngStorageClass.getASyng('splashShahrdar' + global.IdCity);


            if (Platform.OS === 'android') {
                NetInfo.fetch().then(state => {
                    let isConnected = state.isConnected;

                    if (isConnected && (dataShahrdar == null)) {
                        this.props.callService(typeExport._baseUrlSainaShahrdar, paramss, typeExport.TypeGetAllDataShardar, typeExport._POST, token, token_fb, imageBack);

                    } else {
                        //  this.props.callServiceError("offline")
                        this.offlineToMain(isConnected, paramss);
                    }
                });
            } else {
                if (this.props.Connection && (dataShahrdar == null)) {

                    // alert('vfhjnn')
                    this.props.callService(typeExport._baseUrlSainaShahrdar, paramss, typeExport.TypeGetAllDataShardar, typeExport._POST, token, token_fb, imageBack);


                } else {
                    this.offlineToMain(this.props.Connection, paramss);
                }
            }
        }
        else if (TypeLogin == 3) {
            // data125 = await AsyngStorageClass.getASyng('splash125' + global.IdCity);


            if (Platform.OS === 'android') {
                NetInfo.fetch().then(state => {
                    let isConnected = state.isConnected;

                    if (isConnected) {
                        this.props.callService(global.UrlWebService125, paramss, typeExport.TypeGetAllData125, typeExport._POST, token, token_fb, imageBack);

                    } else {
                        this.props.callServiceError("offline125")
                        // this.offlineToMain(isConnected);
                    }
                });
            } else {
                if (this.props.Connection && (data125 == null)) {


                    this.props.callService(global.UrlWebService125, paramss, typeExport.TypeGetAllData125, typeExport._POST, token, token_fb, imageBack);


                } else {
                    this.offlineToMain(this.props.Connection, paramss);
                }
            }
        }
        else {
            alert("!!!!!!")
        }

    }


    failedRetry() {
        switch (this.state.type_getData) {
            case typeExport.TypeGetAllData:
                this.getData();
                break;
            case typeExport.TypeGetCityData:
                // this.props.callService(urlGetCityData, "", TypeGetCityData, 'GET')

                break;
        }
    }

    resizeModal(env) {
        this.setState({modalHeight: env.nativeEvent.layout.height + 10});
    }

    render() {
        const {navigation} = this.props;

        return (
            <View style={{flex: 1, alignItems: 'center', justifyContent: 'center'}}>
                {/*      <TouchableOpacity
                    onPress={() => {
                        navigation.replace("HomeScreen")
                    }}
                    style={{width: "100%", height: 100, alignItems: 'center', justifyContent: 'center'}}
                >
                    <Text>cdvsdfsdfsdds</Text>
                </TouchableOpacity>*/}
                <View
                    style={{
                        position: 'relative',
                        width: '100%',
                        height: '100%',
                        //  backgroundColor: '#eaeaea',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                    {/*      <TouchableOpacity
                    onPress={() => {
                        navigation.replace("HomeScreen")
                    }}
                    style={{width: "100%", height: 100, alignItems: 'center', justifyContent: 'center'}}
                >
                    <Text>cdvsdfsdfsdds</Text>
                </TouchableOpacity>*/}

                    <LottieView
                        resizeMode="cover"
                        speed={.4}
                        style={{position: 'absolute', width: '100%', height: '100%'}}
                        autoSize={true}
                        source={PathFile.animation.pulse} autoPlay loop/>


                    <LottieView
                        speed={.6}
                        resizeMode="cover"
                        style={{
                            position: 'absolute',
                            width: typeExport._WIDTH / (1.2),
                            height: typeExport._WIDTH / (1.2),
                        }}
                        source={PathFile.animation.pulse} autoPlay loop/>

                    <LottieView
                        speed={.5}
                        resizeMode="cover"
                        style={{position: 'absolute', width: typeExport._WIDTH / 3, height: typeExport._WIDTH / 3}}
                        source={PathFile.animation.pulse} autoPlay loop/>

                    <View style={{
                        width: 120,
                        height: 120,
                        position: 'absolute',
                        borderRadius: 60,
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: "#fff",
                    }}>

                        {/*       <HMTextView
                                type={"bold"}
                                style={{
                                    position: 'absolute',
                                    bottom: 0,
                                    fontSize: 12),
                                    marginBottom: 6),
                                    color: Colors.blackLight,
                                    // marginTop: 10)
                                }}
                                text={typeExport.NameApp}
                                //   text={"یببل"}
                            />*/}
                    </View>
                    <Image

                        resizeMode={"contain"}
                        style={{
                            width: 110,
                            height: 110,
                            //position: 'absolute',
                            //borderRadius: 50),
                            //  backgroundColor: Colors.white


                        }}
                        source={PathFile.image.logo}
                    />


                </View>
                {
                    this.props.NoInternetDialog ?
                        <DialogConnectionCustomize onPress={() => this.getData()}/> : null
                }
            </View>

        );
    }
}
